import styled from 'styled-components';
import { colorsVariables as colors } from '../GlobalStyles';

export const Page = styled.main`
	direction: rtl;
	max-width: 1240px;
	margin: auto;
	padding: 40px 24px 70px;
	line-height: 1.65;
	h1 {
		font-size: clamp(30px, 4vw, 52px);
		line-height: 1.2;
		margin-bottom: 24px;
	}
	h2 {
		font-size: 26px;
		margin-bottom: 16px;
	}
	h3 {
		font-size: 20px;
	}
	p {
		margin-bottom: 12px;
	}
	section {
		scroll-margin-top: 110px;
	}
	a {
		text-decoration: underline;
		text-underline-offset: 4px;
	}
	button,
	input,
	select,
	textarea {
		font: inherit;
	}
	button {
		cursor: pointer;
	}
	button:disabled {
		cursor: default;
		opacity: 0.6;
	}
	input:not([type='checkbox']),
	select,
	textarea {
		width: 100%;
		min-height: 44px;
		padding: 8px;
		border: 1px solid ${colors.secLight};
		background: white;
		border-radius: 0;
	}
	input[type='checkbox'] {
		width: 22px;
		height: 22px;
		accent-color: ${colors.secDark};
		flex-shrink: 0;
	}
	label {
		display: block;
		margin-bottom: 16px;
	}
	:focus-visible {
		outline: 3px solid ${colors.mainDark};
		outline-offset: 3px;
	}
	fieldset {
		border: 0;
		margin: 24px 0;
		min-width: 0;
	}
	legend {
		font-weight: bold;
		font-size: 20px;
		margin-bottom: 12px;
	}
	@media (max-width: 650px) {
		padding: 24px 16px 100px;
		h2 {
			font-size: 24px;
		}
	}
`;

export const Panel = styled.section`
	background: #f4f4f1;
	padding: 24px;
	margin-bottom: 24px;
	min-width: 0;
	@media (max-width: 650px) {
		padding: 18px;
	}
`;

export const Columns = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 1.65fr) minmax(300px, 1fr);
	gap: 32px;
	align-items: start;
	@media (max-width: 850px) {
		grid-template-columns: 1fr;
		gap: 12px;
	}
`;

export const Action = styled.button`
	background: ${colors.secDark};
	color: ${colors.mainDark};
	padding: 12px 20px;
	min-height: 46px;
	margin: 8px 0;
	font-weight: bold;
`;

export const Check = styled.label`
	display: flex !important;
	gap: 12px;
	align-items: start;
	cursor: pointer;
	input {
		margin-top: 5px;
	}
`;

export const Message = styled.p`
	padding: 12px;
	background: #fff3dc;
	color: #4c3211;
	overflow-wrap: anywhere;
`;
